import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-file-excel-2-line text-lg text-white"></i>
              </div>
              <span className="font-heading font-semibold text-lg text-background-50">
                VigorBuy Spreadsheet
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              Your trusted knowledge center for everything about VigorBuy Spreadsheet. Discover guides, reviews, templates, and productivity strategies.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
              <a href="#quick-links" className="hover:text-primary-400 transition-colors">Quick Links</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Home</Link></li>
              <li><Link to="/article/what-is-vigorbuy-spreadsheet" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Complete Guide</Link></li>
              <li><a href="#benefits" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Features &amp; Benefits</a></li>
              <li><a href="#faq" className="text-sm text-background-300 hover:text-primary-400 transition-colors">FAQ</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
              <a href="#categories-footer" className="hover:text-primary-400 transition-colors">Categories</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
              <span>More Categories</span>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} VigorBuy Spreadsheet Knowledge Center. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-background-400 hover:text-primary-400 transition-colors"
            >
              Visit Main Site
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}